module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"instaloan_accounts":"My InstaLoan Accounts","instaloan_account":"My InstaLoan Account"}}')
  delete Component.options._Ctor
}
